import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { formatPolicyStatusLabel, getPolicyStatusBadgeClass } from "./policy-status";

interface Props {
  status?: string | null;
  className?: string;
}

export function PolicyStatusBadge({ status, className }: Props) {
  return (
    <Badge
      variant="outline"
      className={cn(
        "rounded-full px-2.5 py-0.5 font-medium",
        getPolicyStatusBadgeClass(status),
        className
      )}
      data-testid={`policy-status-badge-${(status ?? "unknown").toLowerCase()}`}
    >
      {formatPolicyStatusLabel(status)}
    </Badge>
  );
}
